import React from "react";

const LogoIcon = ({ width = 20, height = 20, color = "white" }) => {
  return (
    <div
      className="logoIcon"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      aria-hidden="true"
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <path
          d="M10.0099 0C15.5157 0 20 4.48434 20 9.99005C20 15.5157 15.5157 20 10.0099 20C4.50423 20 1.90735e-06 15.5157 1.90735e-06 9.99005C-0.000993729 4.48434 4.50423 0 10.0099 0ZM3.1825 14.7151C5.3645 14.9557 7.7275 15.0154 10.0099 15.0154C12.2924 15.0154 14.6544 14.9557 16.8573 14.7151C17.4779 14.6554 17.7981 14.4953 17.8787 13.8339C17.999 12.5728 17.999 11.2909 17.999 9.99005C17.999 8.7091 17.999 7.42715 17.8787 6.16609C17.7981 5.50572 17.4779 5.3456 16.8573 5.28493C14.6554 5.04426 12.2924 4.98458 10.0099 4.98458C7.7275 4.98458 5.36549 5.04426 3.1825 5.28493C2.54202 5.3446 2.22178 5.50472 2.14122 6.16609C2.04078 7.42715 2.04078 8.7091 2.04078 9.99005C2.04078 11.2909 2.04078 12.5728 2.14122 13.8339C2.22079 14.4943 2.54202 14.6544 3.1825 14.7151Z"
          fill={color}
        />
        <path
          d="M14.0537 9.99006C14.0537 7.78817 12.2914 5.9463 10.0099 5.9463C7.7275 5.9463 5.96619 7.78817 5.96619 9.99006C5.96619 12.2128 7.7275 14.0547 10.0099 14.0547C12.2924 14.0547 14.0537 12.2128 14.0537 9.99006Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default LogoIcon;